import { getDefaultOptions as y } from "./_lib/defaultOptions.js";
import { formatters as P } from "./_lib/format/formatters.js";
import { longFormatters as A } from "./_lib/format/longFormatters.js";
import { isProtectedWeekYearToken as L, isProtectedDayOfYearToken as $, warnOrThrowProtectedError as j } from "./_lib/protectedTokens.js";
import { isValid as I } from "./isValid.js";
import { toDate as Q } from "./toDate.js";
import { enUS as q } from "./locale/en-US.js";
const H = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, K = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, M = /^'([^]*?)'?$/, U = /''/g, V = /[a-zA-Z]/;
function b(t, n, e) {
  var i, s, k, u, d, g, h, w, D, T, O, E, v, C, S, R, W, x;
  const c = y(), l = (s = (i = e == null ? void 0 : e.locale) != null ? i : c.locale) != null ? s : q, Y = (T = (D = (g = (d = e == null ? void 0 : e.firstWeekContainsDate) != null ? d : (u = (k = e == null ? void 0 : e.locale) == null ? void 0 : k.options) == null ? void 0 : u.firstWeekContainsDate) != null ? g : c.firstWeekContainsDate) != null ? D : (w = (h = c.locale) == null ? void 0 : h.options) == null ? void 0 : w.firstWeekContainsDate) != null ? T : 1, z = (x = (W = (C = (v = e == null ? void 0 : e.weekStartsOn) != null ? v : (E = (O = e == null ? void 0 : e.locale) == null ? void 0 : O.options) == null ? void 0 : E.weekStartsOn) != null ? C : c.weekStartsOn) != null ? W : (R = (S = c.locale) == null ? void 0 : S.options) == null ? void 0 : R.weekStartsOn) != null ? x : 0, o = Q(t);
  if (!I(o))
    throw new RangeError("Invalid time value");
  let f = n.match(K).map((a) => {
    const r = a[0];
    if (r === "p" || r === "P") {
      const m = A[r];
      return m(a, l.formatLong);
    }
    return a;
  }).join("").match(H).map((a) => {
    if (a === "''")
      return { isToken: !1, value: "'" };
    const r = a[0];
    if (r === "'")
      return { isToken: !1, value: Z(a) };
    if (P[r])
      return { isToken: !0, value: a };
    if (r.match(V))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + r + "`"
      );
    return { isToken: !1, value: a };
  });
  l.localize.preprocessor && (f = l.localize.preprocessor(o, f));
  const F = {
    firstWeekContainsDate: Y,
    weekStartsOn: z,
    locale: l
  };
  return f.map((a) => {
    if (!a.isToken)
      return a.value;
    const r = a.value;
    (!(e != null && e.useAdditionalWeekYearTokens) && L(r) || !(e != null && e.useAdditionalDayOfYearTokens) && $(r)) && j(r, n, String(t));
    const m = P[r[0]];
    return m(o, r, l.localize, F);
  }).join("");
}
function Z(t) {
  const n = t.match(M);
  return n ? n[1].replace(U, "'") : t;
}
export {
  b as default,
  b as format,
  b as formatDate,
  P as formatters,
  A as longFormatters
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/format.js
// module id = 209
// module chunks = 67